import React, { useState } from 'react';
import styles from '../robertinhotattooarts/robertinhotattooarts.module.scss';
import Perfil from './src/perfil.png';
import Instagram1 from './src/instagram1.png';
import Instagram2 from './src/instagram2.png';
import LinkPersonalizado7 from '../../components/LinkPersonalizado7/linkPersonalizado7.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import FacebookIcon from '../../icons/facebookIcon.tsx';
import TattooIcon from '../../icons/tattooIcon.tsx';
import CatalogIcon from '../../icons/catalogIcon.tsx';

const Robertinhotattooarts: React.FC = () => {
    const [showInstagrams, setShowInstagrams] = useState(false);

    return (
        <div className={styles.robertinhotattooarts}>
            <div className={styles["body-thunder"]}>
                <div className={`${styles["container-thunder"]}`} >
                    <img className={styles["img-perfil"]} src={Perfil} />
                    <div className={`${styles.links} mb-2`}>
                        <LinkPersonalizado7
                            href="https://wa.me/5518997951461?text=Olá, vim pelo link na bio e gostaria de mais informações..."
                            title="WHATSAPP"
                            icon={<WhatsappIcon height="36" color="#ffffff" />}
                            colorText="#cbb353"
                        />
                        <LinkPersonalizado7
                            href="https://www.facebook.com/share/1QhqZopD9j/?mibextid=wwXIfr"
                            title="FACEBOOK"
                            icon={<FacebookIcon height="36" color="#ffffff" />}
                            colorText="#cbb353"
                            linkInterno={true}
                        />
                        <div className={styles.link} onClick={() => setShowInstagrams(true)}>
                            <LinkPersonalizado7
                                noLink
                                href=""
                                title="INSTAGRAM"
                                icon={<InstagramIcon height="32" color="#ffffff" />}
                                colorText="#cbb353"
                            />
                        </div>
                    </div>
                    <div className={styles.links}>
                        <LinkPersonalizado7
                            href="https://maps.app.goo.gl/gsz8eDGiUeehrH1k7"
                            title="LOCALIZAÇÃO"
                            icon={<MapsIcon height="36" color="#ffffff" />}
                            colorText="#cbb353"
                        />
                        <LinkPersonalizado7
                            href="/robertinhotattooarts/sobremim"
                            title="SOBRE MIM"
                            icon={<CatalogIcon height="34" color="#ffffff" />}
                            colorText="#cbb353"
                            linkInterno={true}
                        />
                        <LinkPersonalizado7
                            href="/robertinhotattooarts/tattoo"
                            title="GALERIA"
                            icon={<TattooIcon height="36" color="#ffffff" />}
                            colorText="#cbb353"
                            linkInterno={true}
                        />
                    </div>
                </div>
            </div>
            {showInstagrams && (
                <div
                    className={styles.modalOverlay}
                    onClick={() => setShowInstagrams(false)}
                >
                    <div
                        className={styles.modalContent}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            className={styles.closeButton}
                            onClick={() => setShowInstagrams(false)}
                        >
                            ✕
                        </button>
                        <h2>Instagram</h2>
                        <div className={styles.modalGrid}>
                            <div className={styles.modalCard}>
                                <img src={Instagram1} />
                                <p>@robertinho_q.o.e.s</p>
                                <a
                                    href="https://www.instagram.com/robertinho_q.o.e.s?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <button className={styles.mapButton}>
                                        <InstagramIcon height="18" color="#fff" />
                                        <span>Acessar</span>
                                    </button>
                                </a>
                            </div>
                            <div className={styles.modalCard}>
                                <img src={Instagram2} />
                                <p>@robertinho.tattoo.arts</p>
                                <a
                                    href="https://www.instagram.com/robertinho.tattoo.arts?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <button className={styles.mapButton}>
                                        <InstagramIcon height="18" color="#fff" />
                                        <span>Acessar</span>
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Robertinhotattooarts;
